/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCategories,
    AssetsMelcoModelsCategoriesFromJSON,
    AssetsMelcoModelsCategoriesFromJSONTyped,
    AssetsMelcoModelsCategoriesToJSON,
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsGenericList1MelcoModelsCategories
 */
export interface AssetsMelcoModelsGenericList1MelcoModelsCategories {
    /**
     * 
     * @type {Array<AssetsMelcoModelsCategories>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsCategories
     */
    list: Array<AssetsMelcoModelsCategories>;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsCategories
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsCategories
     */
    total: number;
}

export function AssetsMelcoModelsGenericList1MelcoModelsCategoriesFromJSON(json: any): AssetsMelcoModelsGenericList1MelcoModelsCategories {
    return AssetsMelcoModelsGenericList1MelcoModelsCategoriesFromJSONTyped(json, false);
}

export function AssetsMelcoModelsGenericList1MelcoModelsCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsGenericList1MelcoModelsCategories {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AssetsMelcoModelsCategoriesFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function AssetsMelcoModelsGenericList1MelcoModelsCategoriesToJSON(value?: AssetsMelcoModelsGenericList1MelcoModelsCategories | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AssetsMelcoModelsCategoriesToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


